<p-autoComplete [(ngModel)]="balzacBook" (ngModelChange)="balzacBookChange.emit($event)"
  name="balzacBook" [disabled]="mode !== DetailMode.EDITION"
  class="balzac-autocomplete acted-highlight-req metadata-field" [required]="required"
  [suggestions]="allBalzacBooks" optionLabel="saga_name" (completeMethod)="getBalzacSuggestions($event)"
  [multiple]="false" [forceSelection]="true"
  [dropdown]="false" dropdownMode="current" i18n-placeholder="@@common-none" placeholder="(none)" appendTo="body" [tabindex]="tabindex">
  <!-- define custom template for filter options -->
  <ng-template pTemplate="item" let-balzacBook>
    {{ balzacBook.saga_name }}
  </ng-template>
</p-autoComplete>

@if (balzacBook?.partner) {
  <div>( {{ balzacBook?.partner?.name }} )</div>
}
